import { render, staticRenderFns } from "./BasicFlow.vue?vue&type=template&id=4a128cba&scoped=true"
import script from "./BasicFlow.vue?vue&type=script&lang=js"
export * from "./BasicFlow.vue?vue&type=script&lang=js"
import style0 from "./BasicFlow.vue?vue&type=style&index=0&id=4a128cba&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a128cba",
  null
  
)

export default component.exports